function hackVanOverflow() {
  try {
    const target = document.body
    const config = { attributes: true }
    const observer = new MutationObserver(() => {
      const classList: string[] = [].slice.call(target.classList)
      if (
        classList.includes('van-overflow-hidden') ||
        classList.includes('van-toast--unclickable')
      ) {
        document.documentElement.style.overflowX = 'unset'
      } else {
        document.documentElement.style.overflowX = ''
      }
    })
    observer.observe(target, config)
  } catch {}
}

hackVanOverflow()
